export default __webpack_public_path__ + "static/media/cancel.7c1a7ad3.svg";